import AboutHeader from "../components/AboutHeader/AboutHeader";
import { AboutContent } from "../styles/Layout.style";
import AboutContainer from "../components/AboutContainer/AboutContainer";

const AboutPage = () => {
  return (
    <AboutContent>
      <AboutHeader
        firstWord={"Somos"}
        secondWord={"Eupha"}
        subtitleOne={"Somos Eupha"}
        subtitleTwoFirst={"Somos"}
        subtitleTwoSecond={"Pharma"}
      />
      <AboutContainer />
    </AboutContent>
  );
};

export default AboutPage;
